"use strict";
var ContentFeed_1;
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const index_1 = require("../../index");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const OsmosysBaseEntity_1 = require("../OsmosysBaseEntity");
const ContentMapping_1 = require("./ContentMapping");
const ContentSystem_1 = require("./ContentSystem");
const emails_1 = require("../emails");
const auth_1 = require("../auth");
let ContentFeed = ContentFeed_1 = class ContentFeed extends OsmosysBaseEntity_1.OsmosysBaseEntity {
    constructor() {
        super(...arguments);
        this.contentPushIsEnabled = false;
        this.contentPushIndividualContentItems = true;
        this.contentPushUrl = `/api/v1/feed/push/${this.contentPushToken}`;
    }
};
ContentFeed.__relations = ['contentSystem', 'contentMapping'];
tslib_1.__decorate([
    type_graphql_1.Field(() => auth_1.User),
    typeorm_1.ManyToOne(() => auth_1.User, {
        cascade: true,
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], ContentFeed.prototype, "creatingUser", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], ContentFeed.prototype, "name", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], ContentFeed.prototype, "url", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Number),
    typeorm_1.Column({
        default: 60,
        nullable: true,
        type: 'integer',
    }),
    tslib_1.__metadata("design:type", Number)
], ContentFeed.prototype, "cacheLength", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: 'json' }),
    class_validator_1.IsIn(['json', 'xml']),
    tslib_1.__metadata("design:type", String)
], ContentFeed.prototype, "responseType", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => ContentSystem_1.ContentSystem),
    typeorm_1.ManyToOne(() => ContentSystem_1.ContentSystem, contentSystem => contentSystem.contentFeeds, {
        nullable: false,
    }),
    typeorm_1.JoinColumn({ name: 'contentSystem' }),
    tslib_1.__metadata("design:type", Object)
], ContentFeed.prototype, "contentSystem", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.RelationId((obj) => obj.contentSystem),
    tslib_1.__metadata("design:type", Number)
], ContentFeed.prototype, "contentSystemId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => ContentMapping_1.ContentMapping, { nullable: true }),
    typeorm_1.ManyToOne(() => ContentMapping_1.ContentMapping, contentMapping => contentMapping.contentFeeds, {
        lazy: true,
        nullable: true,
    }),
    tslib_1.__metadata("design:type", Object)
], ContentFeed.prototype, "contentMapping", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [ContentMapping_1.ContentMapping]),
    typeorm_1.OneToMany(() => ContentMapping_1.ContentMapping, contentMapping => contentMapping.sampleContentFeed),
    tslib_1.__metadata("design:type", Object)
], ContentFeed.prototype, "sampledForContentMappings", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [emails_1.EmailTemplateBlock]),
    typeorm_1.OneToMany(() => emails_1.EmailTemplateBlock, block => block.contentFeed),
    tslib_1.__metadata("design:type", Object)
], ContentFeed.prototype, "blocksUsedIn", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => index_1.GraphQLJSON, { nullable: true }),
    typeorm_1.Column({
        default: null,
        nullable: true,
        type: 'jsonb',
    }),
    class_validator_1.IsOptional(),
    class_validator_1.IsJSON({
        message: 'Must be valid JSON',
    }),
    tslib_1.__metadata("design:type", Object)
], ContentFeed.prototype, "headers", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => ContentFeed_1, { nullable: true })
    // @ManyToOne(type => ContentFeed, cf => cf.useHeadersFromContentFeed)
    ,
    typeorm_1.ManyToOne(() => ContentFeed_1, {
        cascade: true,
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], ContentFeed.prototype, "useHeadersFromContentFeed", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    typeorm_1.Column({ default: false, type: 'boolean' }),
    tslib_1.__metadata("design:type", Boolean)
], ContentFeed.prototype, "contentPushIsEnabled", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    typeorm_1.Column({ default: true, type: 'boolean' }),
    tslib_1.__metadata("design:type", Boolean)
], ContentFeed.prototype, "contentPushIndividualContentItems", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '', unique: false }),
    tslib_1.__metadata("design:type", String)
], ContentFeed.prototype, "contentPushToken", void 0);
ContentFeed = ContentFeed_1 = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    typeorm_1.Entity()
], ContentFeed);
exports.ContentFeed = ContentFeed;
class ContentFeedEntity extends ContentFeed {
    toEndpoint() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const cs = yield this.contentSystem;
            if (!cs) {
                return `/integrations?failed=${encodeURI('No content system found')}`;
            }
            return `/integrations/${(yield this.contentSystem).id}/feeds/${this.id}`;
        });
    }
    toString() {
        return this.name;
    }
}
exports.ContentFeedEntity = ContentFeedEntity;
//# sourceMappingURL=ContentFeed.js.map